(function LivePlannerVideo($, Adzuki)
{
	"use strict";

	var LPVideo              = {};
	var current_meeting_id   = null;
	var current_type         = null;
	var current_meeting_type = 'meeting';

	LPVideo.browserSupportsZoomAudio = function _browserSupportsZoomAudio()
	{
		var support = _getZoomSupport();

		return support.audio;
	};

	LPVideo.browserSupportsZoomVideo = function _browserSupportsZoomVideo()
	{
		var support = _getZoomSupport();

		return support.audio && support.video;
	};

	LPVideo.browserSupportsFullZoomPlayer = function _browserSupportsFullZoomPlayer()
	{
		return typeof SharedArrayBuffer === 'function' && window.crossOriginIsolated;
	};

	// end the zoom meeting, only the agent can do this
	LPVideo.endZoomMeeting = function _endZoomMeeting()
	{
		Cookies.set('lp_confirm_video_close', 0);

		Adzuki.Ajax.get('/LivePlanner/endZoomMeeting')
		.then(function _endMeeting(response) {
			if (response.error) {
				_logError('Error ending the meeting: ' + response.error, 'end_meeting');
			}
		}).catch(function _endMeetingError(err) {
			_throwError('Error ending the meeting: ' + err, 'end_meeting');
		});
	};

	LPVideo.joinZoomGroupMeeting = function _joinZoomGroupMeeting()
	{
		// join meeting should be used by the client, since the agent starts the meeting
		_startZoomMeeting(0, true);
	};

	LPVideo.joinZoomPeerMeeting = function _joinZoomPeerMeeting()
	{
		// the client joins the P2P meeting created by the agent
		_startZoomMeeting(0, false);
	};

	// leave the zoom meeting, only the client should be able to do this
	LPVideo.leaveMeeting = function _leaveMeeting()
	{
		ZoomMtg.leaveMeeting({
			confirm: false,
			error  : function _onError(error) {
				_logError(error.errorMessage, 'leave_meeting');
			},
			success: function _onSucess() {
				// nothing to do
			}
		});
	};

	LPVideo.startZoomGroupMeeting = function _startZoomGroupMeeting()
	{
		// role in the SDK signature needs to be 1,
		// since the agent is the one that starts the meeting
		_startZoomMeeting(1, true);
	};

	LPVideo.startZoomPeerMeeting = function _startZoomPeerMeeting()
	{
		// the agent is the only one that can start a P2P meeting
		_startZoomMeeting(1, false);
	};

	function _getZoomSupport()
	{
		var client = null;
		var media  = null;
		var compat = {
			video : false,
			audio : false,
			screen: false,
		};

		if (Adzuki.https) {
			client        = ZoomMtgEmbedded.createClient();
			media         = client.checkSystemRequirements();
			compat.video  = media.video;
			compat.audio  = media.audio;
			compat.screen = media.screen;

			// destroy temporary client
			ZoomMtgEmbedded.destroyClient();
		}

		return compat;
	}

	function _logError(msg, action)
	{
		var post_data = {
			generated_by : current_type,
			room_name    : current_meeting_id,
			action       : action,
			error        : true,
			error_message: msg,
		};

		Adzuki.Ajax.post('/LivePlanner/logVideoAction', post_data);
	}

	function _setDefaultVirtualBackgroundImage()
	{
		ZoomMtg.isSupportVirtualBackground({
			error: function _onError(error) {
				_logError('Error checking for VB support: ' + error.errorMessage, 'start_' + current_meeting_type);
			},
			success: function _onSucess(response) {
				if (response.errorMessage) {
					_logError('VB for Meeting is not supported: ' + response.errorMessage, 'start_' + current_meeting_type);

					return;
				}

				Adzuki.Ajax.get('/LivePlanner/getAgentBackgroundImage')
				.then(function response(response) {
					var image_id = null;

					if (!response) {
						_logError('There was a problem getting agent background image', 'start_' + current_meeting_type);
						return;
					}

					// no background set
					if (response.image === 'none') {
						return;
					}

					// blur background
					if (response.image === 'blur') {
						image_id = 'blur';
					} else {
						image_id = response.id;
					}

					ZoomMtg.setVirtualBackground({
						id   : image_id,
						error: function _onError(error) {
							_logError('Error setting the default VB: ' + error.errorMessage, 'start_' + current_meeting_type);
						},
						success: function _onSucess(response) {
							if (response.errorMessage) {
								_logError('An error was encountered when setting the default VB: ' + response.errorMessage, 'start_' + current_meeting_type);

								return;
							}
						}
					});
				});
			}
		});
	}

	function _startZoomMeeting(role, group_meeting)
	{
		var view         = 'speaker';
		var share_screen = true;

		current_type = 'client';

		// a group meeting was started
		if (group_meeting) {
			current_meeting_type = 'group_meeting';
		}

		// meeting was started by the agent
		if (role) {
			current_type = 'agent';
			share_screen = false;
		}

		// enable gallery view if the browser supports it
		if (LPVideo.browserSupportsFullZoomPlayer()) {
			view = 'gallery';
		}

		// init sdk elements
		ZoomMtg.preLoadWasm();
		ZoomMtg.prepareWebSDK();

		// initialize and render the client
		ZoomMtg.init({
			leaveUrl         : Adzuki.base_uri + '/LivePlanner/videoEnded',
			defaultView      : view,
			disableInvite    : true,
			disablePreview   : true,
			disableZoomLogo  : true,
			isSupportChat    : false,
			isSupportBreakout: false,
			screenShare      : share_screen,
			success          : function onSuccess() {
				var url = '/LivePlanner/getZoomSignature';

				if (role > 0) {
					url += '/1';
				}

				Adzuki.Ajax.get(url).then(function response(response) {
					var signature = null;

					if (response.error) {
						_throwError(response.error, 'start_' + current_meeting_type);
						return;
					}

					signature          = response.jwt;
					current_meeting_id = response.meeting_id;

					ZoomMtg.join({
						sdkKey       : response.sdk_key,
						signature    : signature,
						meetingNumber: response.meeting_id,
						userName     : response.username,
						passWord     : response.password,
						success      : function onSuccess() {
							// update virtual background options for agents
							if (role) {
								_updateVirtualBackgroundList();
							}
						},
						error: function onError(err) {
							_throwError(err, 'start_' + current_meeting_type);
						}
					});
				}).catch(function onError(err) {
					_throwError('Response Error: ' + err, 'start_' + current_meeting_type);
				});
			},
			error: function onError(err) {
				_throwError('Unknown Error: ' + err, 'start_' + current_meeting_type);
			}
		});

		// event handler when the meeting ends (only the agent's side handles this event)
		if (current_type === 'agent') {
			ZoomMtg.inMeetingServiceListener('onMeetingStatus', function _meetingStatusChanged(data) {
				if (data.meetingStatus && data.meetingStatus === 3) {
					Cookies.set('lp_confirm_video_close', 0);

					// send enotifyd message to end the video call
					Adzuki.Ajax.get('/LivePlanner/endVideo').then(function _endVideo(response) {
						// nothing to do
					});
				}
			});
		}

		// event handler when the client leaves the meeting (only the client's side handles this event)
		if (current_type === 'client') {
			ZoomMtg.inMeetingServiceListener('onUserLeave', function _userLeave(data) {
				Cookies.set('lp_confirm_video_close', 0);

				// send enotifyd message that the client left the meeting
				Adzuki.Ajax.get('/LivePlanner/leaveVideo').then(function _leaveVideo(response) {
					// nothing to do
				});
			});
		}
	}

	function _throwError(msg, action)
	{
		_logError(msg, action);

		throw new Error(msg);
	}

	function _updateVirtualBackgroundList()
	{
		ZoomMtg.isSupportVirtualBackground({
			error: function _onError(error) {
				_logError('Error checking for VB support: ' + error.errorMessage, 'start_' + current_meeting_type);
			},
			success: function _onSucess(response) {
				if (response.errorMessage) {
					_logError('VB for meeting is not supported: ' + response.errorMessage, 'start_' + current_meeting_type);

					return;
				}

				Adzuki.Ajax.get('/LivePlanner/getVirtualBackgrounds')
				.then(function response(response) {
					var backgrounds = [];

					if (!response) {
						_logError('There was a problem getting the list of background images', 'start_' + current_meeting_type);
						return;
					}

					$.each(response.images, function _onEachImage(i, image) {
						var id = image.id;

						// special case for the blur background image
						if (parseInt(id) === 1) {
							id = 'blur';
						}

						backgrounds.push({
							displayName: image.text,
							fileName   : image.file_name,
							id         : id,
							url        : image.url,
						});
					});

					// no backgrounds found
					if (backgrounds.length === 0) {
						return;
					}

					// update the listing of virtual backgrounds
					ZoomMtg.updateVirtualBackgroundList({
						vbList: backgrounds,
						error : function _onError(error) {
							_logError('Error updating the listing of VB: ' + error.errorMessage, 'start_' + current_meeting_type);
						},
						success: function _onSucess(response) {
							_setDefaultVirtualBackgroundImage();
						}
					});
				});

			}
		});
	}

	Adzuki.LPVideo = LPVideo;

}(jQuery, window.Adzuki || {}));
